<script>
  import { performSearch } from '../search-module.js';
  import { facetValues, lastUpdatedFacet, searching } from '../store.js';
  /** @type {{facet?: any}} */
  let { facet = $bindable({}) } = $props();

  let showAllResults = $derived(facet.selectedValues.length > 0);
  let mergedResults = $derived.by(() => {
    const results = facet.config.values.map((value) => {
      let showAllForCurrent = !facet.selectedValues.includes(value.value);
      let valueCount = facet.values.find((v) => v.value === value.value)?.count ?? 0;
      return {
        ...value,
        count: valueCount,
        showingAll: !$searching && showAllResults && showAllForCurrent,
      };
    });

    // note: swapped default w/ sortByCount (unused for phase 1)
    if (facet.config.sortAlphabetical) {
      results.sort((a, b) => a.name.localeCompare(b.name));
    } else if (facet.values.some((value) => value.value.toLowerCase() === 'news')) {
      // AEC wants specific sorting on news listings
      // TODO: CMS controlled order instead of hardcoded
      // Likely keep as a global-level config instead of per news listing?
      var referenceOrder = ['news', 'features', 'research'];
      results.sort(
        (a, b) =>
          referenceOrder.indexOf(a.value.toLowerCase()) -
          referenceOrder.indexOf(b.value.toLowerCase())
      );
    } else {
      // default by number of tagged results; biggest -> smallest
      results.sort((a, b) => {
        let s = (b.count - a.count) * 100;
        s += a.name.localeCompare(b.name);
        return s;
      });
    }

    return results;
  });

  let currentValues = $derived(mergedResults);

  function update() {
    $facetValues = $facetValues;
    $lastUpdatedFacet = facet.name;

    // Debounce update submission
    // if (timeout) clearTimeout(timeout);
    // timeout = setTimeout(performSearch, 400);
    performSearch(1);
  }
</script>

{#if currentValues.length > 0}
  <fieldset class="facet-group is-open" data-search-module-facet={facet.config.name}>
    <!-- <FacetLabel {facet} /> -->

    <ul class="facet-list">
      {#each currentValues as value (value.value)}
        {@const id = `facet_filter_${facet.name}_${value.value}`}
        <li data-search-module-facet-value={value.name}>
          <label class="simple-facet-item" for={id}>
            <input
              type="checkbox"
              {id}
              name={id}
              value={value.value}
              bind:group={facet.selectedValues}
              onchange={update}
            />
            <span class="facet-label">
              {#if value.Icon}
                <i class="fa {value.Icon}"></i>
              {/if}
              {value.Name || value.name}
              <sup class="result-count">
                {value.count}
              </sup>
            </span>
          </label>
        </li>
      {/each}
    </ul>
  </fieldset>
{/if}
